import { createSlice, createSelector, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import { authApi } from 'app/services/edpApiV1/auth';

type ViewerCredentials = { isAuth: boolean; token: string | null; refreshToken: string | null };

const initialState = { isAuth: false, token: null, refreshToken: null } as ViewerCredentials;
export const credentialsSlice = createSlice({
  name: 'viewer/credentials',
  initialState,
  reducers: {
    setIsAuth: (state, { payload }: PayloadAction<boolean>) => {
      state.isAuth = payload;
    },
    setCredentials: (
      state,
      { payload: { token, refreshToken } }: PayloadAction<{ token: string; refreshToken: string }>,
    ) => {
      state.token = token;
      state.refreshToken = refreshToken;
    },
    reset: () => initialState,
  },
  extraReducers: builder => {
    builder.addMatcher(authApi.endpoints.login.matchFulfilled, (state, { payload }) => {
      if (payload.token) {
        state.isAuth = true;
        state.token = payload.token;
        state.refreshToken = payload.refreshToken;
      }
    });
    builder.addMatcher(authApi.endpoints.changePass.matchFulfilled, (state, { payload }) => {
      if (payload.token) {
        state.isAuth = true;
        state.token = payload.token;
        state.refreshToken = payload.refreshToken;
      }
    });

    builder.addMatcher(authApi.endpoints.logout.matchFulfilled, () => initialState);
  },
});

const selectViewerCredentials = (state: RootState) => state.entities.viewer.credentials;
const getIsAuth = createSelector(selectViewerCredentials, ({ isAuth }) => isAuth);

export const selectors = { getIsAuth };
export const actions = credentialsSlice.actions;
export const reducer = credentialsSlice.reducer;
